import { Link } from 'react-router-dom';
import type { components } from '@bookingdei/api-client/types';
import { api } from '../api';
import { categoryTileIcon } from '../screens/offers/category-tile-icon';
import { BottomSheet } from './bottom-sheet';
import { useLanguage } from './language-context';
import { useResource } from './use-resource';

type CategoryList = components['schemas']['CategoryList'];

// The tab bar's categories sheet (design DC:3811-3828, rows DC:4812-4816). A grabber,
// "All categories", and a two-column grid of the first ten registry categories, each
// a link to search with that category applied. The icon is the design's per-category
// SVG, keyed by registry id with a neutral fallback (FR-L6: adding a category is data).
export function CategoriesSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t, lang } = useLanguage();
  const categories = useResource<CategoryList | null>(
    (signal) => (open ? (api.GET('/registries/categories', { signal, lang }) as Promise<CategoryList>) : Promise.resolve(null)),
    [open, lang],
  );
  const rows = (categories.data?.items ?? []).filter((c) => c.enabled !== false).slice(0, 10);

  return (
    <BottomSheet open={open} onClose={onClose} title={t('sheet.all_categories')} grabber className="sheet--cats">
      <div className="catsheet">
        {rows.map((c) => (
          <Link key={c.id} className="catsheet__row" to={`/search?category=${encodeURIComponent(c.id)}`} onClick={onClose}>
            <span className="catsheet__ico" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d={categoryTileIcon(c.id)} />
              </svg>
            </span>
            <span className="catsheet__label">{(lang === 'bn' ? c.label_bn : c.label_en) ?? c.label_en}</span>
          </Link>
        ))}
      </div>
    </BottomSheet>
  );
}
